module.exports = __webpack_public_path__ + "img/ydd_downLoad1.44f3367e.png";